import styled from "styled-components";

export const EntityLinkWrapper = styled.span`
    display: inline-block;
    text-decoration: ${(props) => (props.lineThrough ? "line-through" : "none")};

    .avatar-container {
        margin-inline-end: 5px;
    }
`;
